// This is an auto-generated file, any edit will be overwritten
module.exports = {
  BotlistMe: require('../src/Interface/Lists/BotlistMe.ts'),
  BotsOnDiscord: require('../src/Interface/Lists/BotsOnDiscord.ts'),
  Carbon: require('../src/Interface/Lists/Carbon.ts'),
  DList: require('../src/Interface/Lists/DList.ts'),
  DiscordBotList: require('../src/Interface/Lists/DiscordBotList.ts'),
  DiscordBotlistEU: require('../src/Interface/Lists/DiscordBotlistEU.ts'),
  DiscordBotsGG: require('../src/Interface/Lists/DiscordBotsGG.ts'),
  DiscordExtremeList: require('../src/Interface/Lists/DiscordExtremeList.ts'),
  DiscordServices: require('../src/Interface/Lists/DiscordServices.ts'),
  DiscordsCom: require('../src/Interface/Lists/DiscordsCom.ts'),
  Disforge: require('../src/Interface/Lists/Disforge.ts'),
  InfinityBotList: require('../src/Interface/Lists/InfinityBotList.ts'),
  Radarcord: require('../src/Interface/Lists/Radarcord.ts'),
  TopGG: require('../src/Interface/Lists/TopGG.ts'),
  VoidBots: require('../src/Interface/Lists/VoidBots.ts'),
  YABL: require('../src/Interface/Lists/YABL.ts')
}
